<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="医生id">
              <a-input placeholder="请输入医生id" v-model="queryParam.settlementId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="患者">
              <a-input placeholder="请输入医生id" v-model="queryParam.userName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="按结算状态">
              <a-select v-model="queryParam.type" placeholder="请输入结算状态">
                <a-select-option value=" ">请选择</a-select-option>
                <a-select-option :value="0">待结算</a-select-option>
                <a-select-option :value="1">已结算</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
<!--            废弃文件-->
          <!--          <a-dropdown>-->
<!--                  <a>-->
<!--                 <router-link :to="`/settlementData/${record.id}`">结算详情</router-link>-->
<!--                 </a>-->
<!--             </a-dropdown>-->
<!--                    <a-divider type="vertical" />-->
          <!--            废弃文件 end-->
             <a @click="handleSettlement(record)">结算详情</a>

        </span>

      </a-table>
    </div>

    <settlement-index-modal ref="settlementIndexModal"></settlement-index-modal>
    <settlement-modal ref="modalForm" @ok="modalFormOk"></settlement-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SettlementModal from './SettlementModal'
  import SettlementIndexModal from './modules/SettlementIndexModal'
  import { getAction } from '@api/manage'

  export default {
    name: 'SettlementList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SettlementModal,
      SettlementIndexModal
    },
    data () {
      return {
        description: 'settlement管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'医生姓名',
            align:"center",
            dataIndex: 'doctorName'
          },
          {
            title:'微信用户',
            align:"center",
            dataIndex: 'userName'
          },
          {
            title:'问诊类型',
            align:"center",
            dataIndex: 'shopType',
            customRender:function (res) {
              var status = "";
              if(res == 1){
                status = "图文";
              }else if(res == 2){
                status = "视频";
              }
              return status;
            }
          },
          {
            title:'结算状态',
            align:"center",
            dataIndex: 'status',
            customRender:function (res) {
              var status = "";
              if(res == 0){
                status = "待结算";
              }else if(res == 1){
                status = "已结算";
              }
              return status;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/settlement/settlement/list",
        },
        dictOptions:{},
      }
    },
    created() {
      this.getAdd(this.$route.params.id);
    },
    methods: {

      getAdd(id){
        let param = {};
        param.settlementId = id

        getAction(this.url.list,param).then(res=>{
          this.list = res.result;
        })
      },
      handleSettlement(record){
        this.$refs.settlementIndexModal.showSettlement(record);
      }




    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>